/* @flow */
import * as React from 'react';

const StorageSmallAlt = props => (
  <svg
    width={61}
    height={51}
    viewBox="0 0 61 51"
    fillRule="evenodd"
    stroke="#1D2C61"
    strokeWidth={2}
    fill="none"
    strokeLinecap="round"
    strokeLinejoin="round"
    {...props}>
    <polygon
      stroke="none"
      strokeWidth={1}
      fill="#FFFFFF"
      points="1.5 10.148 60.5 10.148 60.5 1.5 1.5 1.5"
    />
    <polygon
      stroke="none"
      strokeWidth={1}
      fill="#FFFFFF"
      points="3 10.148 3 50 14.023 50 14.023 38.846 46.978 38.846 46.978 50 57.946 50 57.946 10.148"
    />
    <rect stroke="none" strokeWidth={1} fill="#FFEF55" x={14} y={31} width={33} height={8} />
    <rect stroke="none" strokeWidth={1} fill="#1D2C61" x={28} y={35} width={5} height={2} rx={1} />
    <polygon points="3 50 58 50 58 10 3 10" />
    <polygon points="14.023 50 46.977 50 46.977 18 14.023 18" />
    <polygon points="14 40 47 40 47 18 14 18" />
    <path d="M14.023,18 L46.977,18" />
    <path d="M14.023,25 L46.977,25" />
    <path d="M14.023,32 L46.977,32" />
    <polygon points="1 10 60 10 60 1 1 1" />
    <rect
      stroke="none"
      strokeWidth={1}
      fill="#1D2C61"
      opacity={0.3}
      x={3}
      y={11}
      width={55}
      height={2}
    />
    <polygon
      stroke="none"
      strokeWidth={1}
      fill="#1D2C61"
      points="15.023 49 45.977 49 45.977 41 15.023 41"
    />
  </svg>
);

export default StorageSmallAlt;



// WEBPACK FOOTER //
// ./src/assets/images/icons/storage-small-alt.js